import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'cevop.marketing.cookie-notice';

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(window.localStorage.getItem(STORAGE_KEY) !== 'dismissed');
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  function dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'dismissed');
    } catch {
      /* ignore */
    }
    setVisible(false);
  }

  return (
    <div
      className="fixed right-4 bottom-4 left-4 z-[90] max-w-[520px] rounded-2xl border border-line bg-panel p-4 shadow-lg md:left-auto"
      role="dialog"
      aria-label="Cookie notice"
    >
      <p className="mb-3 text-[0.8rem] leading-[1.6] text-ink-2">
        This marketing site does not load analytics or advertising cookies. The Business and POS apps use necessary
        storage for sign-in. See the{' '}
        <Link to="/privacy" className="font-semibold text-brand">
          Privacy Policy
        </Link>
        .
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="rounded-lg bg-brand px-4 py-2 text-[0.8rem] font-semibold text-brand-on hover:bg-brand-hover"
      >
        OK
      </button>
    </div>
  );
}
